/* eslint-disable import/prefer-default-export */
// Local Dev
// export const REST_ENDPOINT = 'http://localhost:3000';
// Dev
// export const REST_ENDPOINT = 'https://dev.purplevisitsapi.com';
// Staging
// export const REST_ENDPOINT = 'https://staging.purplevisitsapi.com';
// Prod
export const REST_ENDPOINT = 'https://prod.purplevisitsapi.com';

// Australia
export const REST_ENDPOINT_AU = 'https://ausprod.purplevisitsapi.com';
